import { render, staticRenderFns } from "./companyinfo.vue?vue&type=template&id=6e9b6e9e&scoped=true"
import script from "./companyinfo.vue?vue&type=script&lang=js"
export * from "./companyinfo.vue?vue&type=script&lang=js"
import style0 from "./companyinfo.vue?vue&type=style&index=0&id=6e9b6e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9b6e9e",
  null
  
)

export default component.exports